import { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function RecentPost({ title, data }) {
  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    return new Date(dateStr).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  return (
    <>
      <h4 className="cs-sidebar_widget_title">{title}</h4>
      <ul className="cs-recent_posts">
        {data?.map((item, index) => (
          <li key={index}>
            <div className="cs-recent_post">
              <Link to={`/blog/${item.id}`} className="cs-recent_post_thumb">
                <div
                  className="cs-recent_post_thumb_in cs-bg"
                  style={{ backgroundImage: `url(http://localhost/cms/assets/${item.hero_image})` }}
                />
              </Link>
              <div className="cs-recent_post_info">
                <h3 className="cs-recent_post_title">
                  <Link to={`/blog/${item.id}`}>{item.title}</Link>
                </h3>
                <div className="cs-recent_post_date cs-primary_40_color">
                  {formatDate(item.date_created)}
                </div>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </>
  );
}
